import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tomos = [{
  num: '01',
  title: 'El Rey de la Minuta',
  emoji: '📘',
  desc: 'Milanesas, papas, tortillas y hamburguesas. Los clásicos argentinos resueltos.',
  color: 'border-blue-200 bg-blue-50/50'
}, {
  num: '02',
  title: 'El Asador Moderno',
  emoji: '📗',
  desc: 'Carnes, pollo y achuras. El asador de departamento que siempre quisiste.',
  color: 'border-emerald-200 bg-emerald-50/50'
}, {
  num: '03',
  title: 'Picadas y Tentaciones',
  emoji: '📙',
  desc: 'Empanadas, nuggets, provoleta y todo para una picada real.',
  color: 'border-orange-200 bg-orange-50/50'
}, {
  num: '04',
  title: 'Fiambrería y Panadería',
  emoji: '📕',
  desc: 'Chipá, medialunas, facturas y panes sin prender el horno.',
  color: 'border-red-200 bg-red-50/50'
}, {
  num: '05',
  title: 'Verde y Crocante',
  emoji: '📓',
  desc: 'Vegetales, bowls y recetas fit sin resignar sabor.',
  color: 'border-stone-300 bg-stone-100/50'
}, {
  num: '06',
  title: 'Manual de Supervivencia',
  emoji: '📔',
  desc: 'Tiempos, temperaturas, limpieza y ahorro energético.',
  color: 'border-amber-200 bg-amber-50/50'
}];
const bonos = [{
  num: '01',
  title: 'Mapa Maestro de Tiempos y Temperaturas',
  desc: 'La tabla rápida para cocinar con seguridad y ajustar cualquier receta a tu freidora.',
  value: '$8.000'
}, {
  num: '02',
  title: 'Planificador de 14 Días de Comidas',
  desc: 'Dos semanas completas de comidas resueltas para usar el pack desde el día 1.',
  value: '$9.000'
}, {
  num: '03',
  title: 'Recetario Express de Salsas y Toques Finales',
  desc: 'Los dips y terminaciones que hacen que cualquier receta simple se sienta premium.',
  value: '$8.000'
}, {
  num: '04',
  title: 'Kit Anti-Fracaso: 27 Errores que Arruinan tus Recetas',
  desc: 'Detectá por qué salió mal y corregilo antes de seguir desperdiciando ingredientes.',
  value: '$9.000'
}];
export function Product() {
  return <section className="py-20 md:py-32 bg-cream relative" data-id="element-205">
      <div className="max-w-5xl mx-auto px-4" data-id="element-206">
        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-207">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-sand text-sm font-bold tracking-widest uppercase text-charcoal mb-6 shadow-sm" data-id="element-208">
            <span className="text-lg" data-id="element-209">🏆</span> AIRPACK™ MEGAPACK
          </div>
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-charcoal mb-6" data-id="element-210">
            6 Tomos + 4 Bonos — 1000 Recetas
          </h2>
          <p className="text-2xl font-serif italic text-ember" data-id="element-211">
            Todo resuelto.
          </p>
        </motion.div>

        {/* 6 Tomos */}
        <div className="mb-24" data-id="element-212">
          <h3 className="text-sm font-bold tracking-widest uppercase text-center text-charcoal/50 mb-10" data-id="element-213">
            6 Tomos Completos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-214">
            {tomos.map((tomo, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className={`p-6 rounded-2xl bg-white border ${tomo.color} shadow-sm flex flex-col h-full`} data-id="element-215">
                <div className="text-xs font-bold tracking-widest text-charcoal/40 mb-4 uppercase" data-id="element-216">
                  Tomo {tomo.num}
                </div>
                <h4 className="text-xl font-serif font-bold text-charcoal mb-3 flex items-start gap-2" data-id="element-217">
                  <span className="text-2xl leading-none" data-id="element-218">{tomo.emoji}</span>
                  <span className="leading-tight" data-id="element-219">{tomo.title}</span>
                </h4>
                <p className="text-charcoal/70 text-sm leading-relaxed mt-auto" data-id="element-220">
                  {tomo.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 md:p-12 border border-sand shadow-editorial mb-32 max-w-4xl mx-auto" data-id="element-221">
          <h3 className="text-2xl font-serif font-bold text-center mb-8" data-id="element-222">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4" data-id="element-223">
            {['Recetas calibradas para freidoras argentinas', 'Ingredientes y cortes del mercado local', 'Tiempos y temperaturas por potencia', 'Técnica explicada paso a paso', 'Variantes económicas de cada receta', '100% español rioplatense'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-224">
                <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-225">
                  <Check size={12} className="text-green-700 stroke-[3]" data-id="element-226" />
                </div>
                <span className="text-charcoal/80 font-medium text-sm md:text-base" data-id="element-227">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>

        {/* Bonos */}
        <div data-id="element-228">
          <div className="text-center mb-12" data-id="element-229">
            <h3 className="inline-flex items-center gap-2 text-2xl md:text-3xl font-serif font-bold bg-white px-6 py-3 rounded-xl border border-sand shadow-sm" data-id="element-230">
              <span data-id="element-231">🎁</span> 4 BONOS — SIEMPRE INCLUIDOS
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-232">
            {bonos.map((bono, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-6 md:p-8 rounded-2xl border border-sand shadow-sm relative overflow-hidden group" data-id="element-233">
                <div className="absolute -right-4 -top-4 text-8xl font-serif font-black text-sand/30 select-none pointer-events-none" data-id="element-234">
                  {bono.num}
                </div>
                <div className="relative z-10" data-id="element-235">
                  <div className="text-xs font-bold tracking-widest text-ember mb-3 uppercase" data-id="element-236">
                    Bono {bono.num}
                  </div>
                  <h4 className="text-xl font-serif font-bold text-charcoal mb-3 pr-8" data-id="element-237">
                    {bono.title}
                  </h4>
                  <p className="text-charcoal/70 text-sm leading-relaxed mb-6" data-id="element-238">
                    {bono.desc}
                  </p>
                  <div className="inline-flex items-center gap-2 bg-cream px-3 py-1.5 rounded-md border border-sand/50 text-sm font-bold" data-id="element-239">
                    <span className="line-through text-charcoal/40" data-id="element-240">
                      {bono.value}
                    </span>
                    <span className="text-ember" data-id="element-241">→ GRATIS</span>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-charcoal text-white rounded-2xl p-6 text-center shadow-xl" data-id="element-242">
            <p className="text-lg md:text-xl font-medium" data-id="element-243">
              <span className="text-white/60 mr-2" data-id="element-244">VALOR TOTAL BONOS</span>
              <span className="line-through text-white/40 mr-2" data-id="element-245">$34.000</span>
              <span className="font-bold text-ember-light" data-id="element-246">
                → GRATIS con tu AirPack
              </span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}